import { EventEmitter, OnInit } from '@angular/core';
import { DiaryTasksService } from '@app/shared/services/diary-tasks.service';
import { SidepanelModalService } from "@app/sidepanel/services/sidepanel-modal.service";
import { ViewTaskDetailImagesComponent } from "@app/shared/cs-components/view-task-details/view-task-detail-images/view-task-detail-images.component";
import { FormBuilder, Validators } from "@angular/forms";
import { AppValidators } from "@app/directives";
import { CsToastBoxService } from "@app/services";
var TaskDetailComponent = /** @class */ (function () {
    function TaskDetailComponent(modalService, fb, diaryTasksService, toastService) {
        this.modalService = modalService;
        this.fb = fb;
        this.diaryTasksService = diaryTasksService;
        this.toastService = toastService;
        this.tasks = [];
        this.loading = false;
        this.error = '';
        this.taskDeleted = new EventEmitter();
        this.showDeleteConfirmationModal = false;
        this.taskToDelete = null;
        this.action = '';
    }
    TaskDetailComponent.prototype.ngOnInit = function () {
        this.deleteConfirmationForm = this.fb.group({
            'confirmationText': ['', [Validators.required, AppValidators.confirmationTextValidator('DELETE')]]
        });
    };
    TaskDetailComponent.prototype.viewImage = function (photos, index) {
        var initialState = {
            photos: photos,
            selectedIndex: index,
        };
        this.bsModalRef = this.modalService.show(ViewTaskDetailImagesComponent, {
            initialState: initialState,
        });
        this.bsModalRef.content.closeBtnName = 'Close';
    };
    TaskDetailComponent.prototype.deleteTask = function (task) {
        this.taskToDelete = task;
        this.showDeleteConfirmationModal = true;
    };
    TaskDetailComponent.prototype.closeDeleteConfirmModal = function () {
        this.showDeleteConfirmationModal = false;
        this.deleteConfirmationForm.reset();
        this.taskToDelete = null;
        this.action = '';
    };
    TaskDetailComponent.prototype.confirmDelete = function () {
        var _this = this;
        if (this.deleteConfirmationForm.valid && this.taskToDelete) {
            this.action = 'deleting';
            this.diaryTasksService.deleteOnsiteTask(this.diaryId, this.taskToDelete.id).subscribe(function (response) {
                _this.tasks = _this.tasks.filter(function (t) { return t !== _this.taskToDelete; });
                _this.toastService.show('Task deleted successfully', 1000);
                _this.closeDeleteConfirmModal();
                _this.taskDeleted.emit();
            }, function (error) {
                console.error('Error deleting task:', error);
                _this.action = 'failed_to_delete';
            });
        }
    };
    return TaskDetailComponent;
}());
export { TaskDetailComponent };
